// MenuButton.tsx
import React from 'react';
import { DropdownButton } from '@appkit4/react-components/dropdown';

export type MenuItem = {
    label: string;
    value: string;
    disabled?: boolean;
    testId?: string;
};

type MenuButtonProps = {
    label: string;
    items: MenuItem[];
    splitButton?: boolean;
    kind?: 'primary' | 'secondary' | 'text';
    disabled?: boolean;
    keepOpenOnSelect?: boolean;
    scrollable?: boolean;
    testId?: string;
    onSelect?: (value: string, item: MenuItem) => void;
};

function MenuButton({
    label,
    items,
    splitButton = false,
    kind = 'primary',
    disabled = false,
    scrollable = true,
    keepOpenOnSelect = false,
    testId,
    onSelect,
}: MenuButtonProps) {
    return (
        <div
            data-testid={testId}
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
        >
            <DropdownButton
                splitButton={splitButton}
                kind={kind}
                disabled={disabled}
                data={items}
                dropdownStyle={
                    scrollable
                        ? { maxHeight: 'min(60vh, 420px)', overflowY: 'auto' }
                        : undefined
                }
                itemTemplate={(label, item) => (
                    <span data-testid={(item as MenuItem).testId}>{label}</span>
                )}
                onSelect={(value, item, event) => {
                    if (keepOpenOnSelect) {
                        event.preventDefault();
                    }
                    if (onSelect) {
                        onSelect(value as string, item as MenuItem);
                    }
                }}
            >
                {label}
            </DropdownButton>
        </div>
    );
}

export default MenuButton;
